import {
    faBan,
    faCalendarAlt,
    faCaretLeft,
    faCaretRight,
    faCity,
    faClose,
    faCommentDots,
    faDesktop,
    faDownload,
    faEdit,
    faEye,
    faEyeSlash,
    faFileEdit,
    faFileLines,
    faFolder,
    faGear,
    faPlus,
    faRefresh,
    faSignInAlt,
    faSignOutAlt,
    faStreetView,
    faTimes,
    faTrashAlt,
    faUser,
    faUsers,
    faUsersGear,
    faUserGroup,
    faArrowsRotate,
    faTriangleExclamation,
    faUserPlus,
    faCircleQuestion,
    faPeopleRoof,
    faCopy,
    faGreaterThan,
    faLessThan,
    faPen,
    faCreditCard,
    faArrowUpRightFromSquare,
    faCheckCircle,
    faCircleInfo,
    faQuestionCircle
  } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  
  export const Iconos = {
    iconoAyuda:  <FontAwesomeIcon icon={faQuestionCircle} style={{ fontSize: "25px", color: "#1d873e"}} />,
    iconoInfo: <FontAwesomeIcon icon={faCircleInfo} style={{ fontSize: "25px", color: "#1d873e"}} />,
    iconoCheck: <FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: "25px", color: "#1d873e"}} />,
    iconoExclusionCentros: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
    iconoUser: <FontAwesomeIcon icon={faUser} />,
    iconoTarjetaCredito: (
      <FontAwesomeIcon
        icon={faCreditCard}
        style={{ fontSize: "23px", color: "#1d873e"}}
      />
    ),
    iconoPen: (
      <FontAwesomeIcon
        icon={faPen}
        style={{ fontSize: "23px", color: "#1d873e" }}
      />
    ),
    iconoUsers: (
      <FontAwesomeIcon
        icon={faPeopleRoof}
        style={{ fontSize: "23px", color: "#1d873e" }}
      />
    ),
    iconoUsersValidadores: <FontAwesomeIcon icon={faUserGroup} style={{ fontSize: "23px", color: "#1d873e" }}/>,
    iconoUserPlus: <FontAwesomeIcon icon={faUserPlus} style={{ fontSize: "23px", color: "#1d873e" }} />,
    iconoUserGear: <FontAwesomeIcon icon={faUsersGear} />,
    iconoGear: <FontAwesomeIcon icon={faGear} />,
    iconoMoverDerecha: (
      <FontAwesomeIcon
        icon={faGreaterThan}
        style={{ fontSize: "35px", color: "#034117" }}
      />
    ),
    iconoMoverIzquierda: (
      <FontAwesomeIcon
        icon={faLessThan}
        style={{ fontSize: "35px", color: "#034117" }}
      />
    ),
    iconoCalendar: (
      <FontAwesomeIcon
        icon={faCalendarAlt}
        style={{ fontSize: "23px", color: "#034117" }}
      />
    ),
    iconoHojaLineas: (
      <FontAwesomeIcon icon={faFileLines} style={{ fontSize: "25px" }} />
    ),
    iconoHojaLineasMini: (
      <FontAwesomeIcon icon={faFileLines} style={{ fontSize: "20px" }} />
    ),
    iconoRefresh: (
      <FontAwesomeIcon icon={faRefresh} style={{ fontSize: "25px" }} />
    ),
    iconoPapelera: (
      <FontAwesomeIcon
        icon={faTrashAlt}
        style={{ fontSize: "25px", color: "#1d873e" }}
      />
    ),
    iconoEditar: (
      <FontAwesomeIcon
        icon={faEdit}
        style={{ fontSize: "25px", color: "#1d873e" }}
      />
    ),
    iconoEditarFichero: (
      <FontAwesomeIcon
        icon={faFileEdit}
        style={{ fontSize: "25px", color: "#1d873e" }}
      />
    ),
    iconoMas: (
      <FontAwesomeIcon
        icon={faPlus}
        style={{ fontSize: "20px", color: "#008000" }}
      />
    ),
    iconoVer: (
      <FontAwesomeIcon
        icon={faEye}
        style={{ fontSize: "25px", color: "#040404" }}
      />
    ),
    iconoNoVer: (
      <FontAwesomeIcon
        icon={faEyeSlash}
        style={{ fontSize: "25px", color: "#040404" }}
      />
    ),
    iconoEliminar: (
      <FontAwesomeIcon
        icon={faTimes}
        style={{ fontSize: "25px", color: "#D60D3D" }}
      />
    ),
    iconoEliminarInsertarSolicitud: (
      <FontAwesomeIcon
        icon={faTimes}
        style={{ fontSize: "20px", color: "#D60D3D", padding: "0px"}}
      />
    ),
    iconoMasInsertarSolicitud: (
      <FontAwesomeIcon
        icon={faPlus}
        style={{ fontSize: "25px", color: "#1d873e" }}
      />
    ),
    iconoMotivacion: (
      <FontAwesomeIcon
        icon={faBan}
        style={{ fontSize: "25px", color: "#D60D3D" }}
      />
    ),
    iconoComentarios: (
      <FontAwesomeIcon
        icon={faCommentDots}
        style={{ fontSize: "25px", color: "#1d873e" }}
      />
    ),
    iconoEntrada: (
      <FontAwesomeIcon
        icon={faSignInAlt}
        style={{ fontSize: "45px", color: "#1d873e" }}
      />
    ),
    iconoDescargar: (
      <FontAwesomeIcon
        icon={faDownload}
        style={{ fontSize: "25px", background: "transparent" }}
      />
    ),
    iconoSalida: (
      <FontAwesomeIcon
        icon={faSignOutAlt}
        style={{
          fontSize: "45px",
          color: "#D60D3D",
          transform: "rotate(180deg)",
        }}
      />
    ),
    iconoRegistrar: (
      <FontAwesomeIcon
        icon={faSignOutAlt}
        style={{
          fontSize: "35px",
          color: "#D60D3D",
          transform: "rotate(180deg)",
        }}
      />
    ),
    iconoFlecha: (
      <FontAwesomeIcon icon={faCaretRight} style={{ fontSize: "25px" }} />
    ),
    iconoFlechaIzquierda: (
      <FontAwesomeIcon icon={faCaretLeft} style={{ fontSize: "25px" }} />
    ),
    iconoCerrar: (
      <FontAwesomeIcon
        icon={faClose}
        style={{ fontSize: "25px" }}
        title="Cerrar"
      />
    ),
    iconoOrganismo: (
      <FontAwesomeIcon
        icon={faFolder}
        style={{ color: "#1d873e", margin: "0 5px 0 5px" }}
      />
    ),
    iconoCentroDirectivo: (
      <FontAwesomeIcon
        icon={faStreetView}
        style={{ color: "#1d873e", margin: "0 5px 0 5px" }}
      />
    ),
    iconoServicio: (
      <FontAwesomeIcon
        icon={faUsers}
        style={{ color: "#1d873e", margin: "0 5px 0 5px" }}
      />
    ),
    iconoServicio1: (
      <FontAwesomeIcon
        icon={faCity}
        style={{ color: "#1d873e", margin: "0 5px 0 5px" }}
      />
    ),
    iconoServicio2: (
      <FontAwesomeIcon
        icon={faDesktop}
        style={{ color: "#1d873e", margin: "0 5px 0 5px" }}
      />
    ),
    iconoReboot: (
      <FontAwesomeIcon
        icon={faArrowsRotate}
        style={{ fontSize: "25px", color: "#040404" }}
      />
    ),
    iconoIncidenciaTerminal: (
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        style={{ fontSize: "25px", color: "#d60d3d" }}
      />
    ),
    iconoInterrogacion: (
      <FontAwesomeIcon 
        icon={faCircleQuestion}
        style={{ color: "#1d873e", margin: "0 5px 0 5px", width: '1rem'}}
      />
    ),
    iconoCopiar: (
      <FontAwesomeIcon 
        icon={faCopy}
        style={{ color: "#1d873e", margin: "0 5px 0 5px", width: '1rem'}}
      />
    ),  
    iconoPDF: (
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        width="24"
        height="24"
        viewBox="0 0 309.267 309.267"
      >
        <title>PDF</title>
        <g>
          <path
            style={{
              fill: "#E2574C",
            }}
            d="M38.658,0h164.23l87.049,86.711v203.227c0,10.679-8.659,19.329-19.329,19.329H38.658
       c-10.67,0-19.329-8.65-19.329-19.329V19.329C19.329,8.65,27.989,0,38.658,0z"
          />
          <path
            style={{
              fill: "#B53629",
            }}
            d="M289.658,86.981h-67.372c-10.67,0-19.329-8.659-19.329-19.329V0.193L289.658,86.981z"
          />
          <path
            style={{
              fill: "#FFFFFF",
            }}
            d="M217.434,146.544c3.238,0,4.823-2.822,4.823-5.557c0-2.832-1.653-5.567-4.823-5.567h-18.44
       c-3.605,0-5.615,2.986-5.615,6.282v45.317c0,4.04,2.3,6.282,5.412,6.282c3.093,0,5.403-2.242,5.403-6.282v-12.438h11.153
       c3.46,0,5.19-2.832,5.19-5.644c0-2.754-1.73-5.49-5.19-5.49h-11.153v-16.903C204.194,146.544,217.434,146.544,217.434,146.544z
        M155.107,135.42h-13.492c-3.663,0-6.263,2.513-6.263,6.243v45.395c0,4.629,3.74,6.079,6.417,6.079h14.159
       c16.758,0,27.824-11.027,27.824-28.047C183.743,147.095,173.325,135.42,155.107,135.42z M155.755,181.946h-8.225v-35.334h7.413
       c11.221,0,16.101,7.529,16.101,17.918C171.044,174.253,166.25,181.946,155.755,181.946z M106.33,135.42H92.964
       c-3.779,0-5.886,2.493-5.886,6.282v45.317c0,4.04,2.416,6.282,5.663,6.282s5.663-2.242,5.663-6.282v-13.231h8.379
       c10.341,0,18.875-7.326,18.875-19.107C125.659,143.152,117.425,135.42,106.33,135.42z M106.108,163.158h-7.703v-17.097h7.703
       c4.755,0,7.78,3.711,7.78,8.553C113.878,159.447,110.863,163.158,106.108,163.158z"
          />
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    ),
  
    iconoDanger: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        className="bi check-circle-fill flex-shrink-0 me-2"
        viewBox="0 0 16 16"
        role="img"
        aria-label="Danger"
      >
        <title>WARNING</title>
        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
      </svg>
    ),
  
    iconoSuccess: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        className="bi check-circle-fill flex-shrink-0 me-2"
        viewBox="0 0 16 16"
        role="img"
        aria-label="Success"
      >
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
      </svg>
    ),
    iconoNonDropdown: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="currentColor"
        className="bi bi-chevron-right float-right"
        viewBox="0 0 16 16"
      >
        <path
          className="color"
          fillRule="evenodd"
          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
        ></path>
      </svg>
    ),
    iconoDropdown: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="currentColor"
        className="bi bi-chevron-down float-right"
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
        ></path>
      </svg>
    ),
    iconoWarning: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 50 50"
      >
        <circle
          style={{
            fill: "#ff4c10",
          }}
          cx="25"
          cy="25"
          r="25"
        />
        <line
          style={{
            fill: "none",
            stroke: "#FFFFFF",
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeMiterlimit: 10,
          }}
          x1="25"
          y1="10"
          x2="25"
          y2="32"
        />
        <line
          style={{
            fill: "none",
            stroke: "#FFFFFF",
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeMiterlimit: 10,
          }}
          x1="25"
          y1="37"
          x2="25"
          y2="39"
        />
      </svg>
    ),
  
    iconoFolder: (
      <svg
        width="50"
        height="50"
        viewBox="0 0 58 58"
        style={{
          enableBackground: "new 0 0 58 58",
        }}
      >
        <path
          style={{
            fill: "#EFCE4A",
          }}
          d="M46.324,52.5H1.565c-1.03,0-1.779-0.978-1.51-1.973l10.166-27.871
      c0.184-0.682,0.803-1.156,1.51-1.156H56.49c1.03,0,1.51,0.984,1.51,1.973L47.834,51.344C47.65,52.026,47.031,52.5,46.324,52.5z"
        />
        <path
          style={{
            fill: "#F4EFDC",
          }}
          d="M10.221,22.656c0.184-0.683,0.803-1.156,1.51-1.156H53v-7H9l-6,6v21.953L10.221,22.656z"
        />
        <path
          style={{
            fill: "#EBBA16",
          }}
          d="M23.571,10.5L20,5.5H1.732C0.776,5.5,0,6.275,0,7.232V49.96c0.069,0.002,0.138,0.006,0.205,0.01
      L3,42.349V20.5l2-2v-8H23.571z"
        />
        <polygon
          style={{
            fill: "#D1BF86",
          }}
          points="5,10.5 5,18.5 9,14.5 51,14.5 51,10.5 "
        />
        <rect
          x="28"
          y="19.5"
          style={{
            fill: "#BFBAA5",
          }}
          width="2"
          height="2"
        />
        <rect
          x="35"
          y="19.5"
          style={{
            fill: "#BFBAA5",
          }}
          width="2"
          height="2"
        />
        <rect
          x="42"
          y="19.5"
          style={{
            fill: "#BFBAA5",
          }}
          width="2"
          height="2"
        />
        <rect
          x="14"
          y="19.5"
          style={{
            fill: "#BFBAA5",
          }}
          width="2"
          height="2"
        />
        <rect
          x="21"
          y="19.5"
          style={{
            fill: "#BFBAA5",
          }}
          width="2"
          height="2"
        />
        <polygon
          style={{
            fill: "#CEC9AE",
          }}
          points="9,20.5 9,14.5 3,20.5 "
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    ),
    iconoFile: (
      <svg width="100" height="100" viewBox="0 0 512 512">
        <path
          style={{
            fill: "#8cd61d",
          }}
          d="M359.571,0H51.268v512h408.774V101.155L359.571,0z"
        />
        <polygon
          style={{
            fill: "#069918",
          }}
          points="359.571,0 256.343,0 256.343,512 460.732,512 460.732,101.155 "
        />
        <polygon
          style={{
            fill: "#067641",
          }}
          points="359.571,0 359.397,100.645 460.732,101.155 "
        />
        <g>
          <rect
            x="119.397"
            y="375.742"
            style={{
              fill: "#068119",
            }}
            width="272.516"
            height="68.129"
          />
          <rect
            x="119.397"
            y="239.484"
            style={{
              fill: "#06610f",
            }}
            width="272.516"
            height="68.129"
          />
        </g>
        <g>
          <rect
            x="256.351"
            y="375.742"
            style={{
              fill: "#03611d",
            }}
            width="136.258"
            height="68.129"
          />
          <rect
            x="256.351"
            y="239.484"
            style={{
              fill: "#054a02",
            }}
            width="136.258"
            height="68.129"
          />
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    ),
    iconoExcel: (
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        width="24"
        height="24"
        viewBox="0 0 512 512"
      >
        <path
          style={{
            fill: "#507C5C",
          }}
          d="M438.557,512H19.785c-8.216,0-14.876-6.66-14.876-14.876V256.916c0-8.216,6.66-14.876,14.876-14.876
      s14.876,6.66,14.876,14.876v225.332h389.021v-32.833c0-8.216,6.661-14.876,14.876-14.876c8.215,0,14.876,6.66,14.876,14.876v47.709
      C453.433,505.34,446.772,512,438.557,512z"
        />
        <g>
          <polygon
            style={{
              fill: "#CFF09E",
            }}
            points="19.785,177.122 19.785,172.332 175.581,14.876 175.581,177.122 	"
          />
          <rect
            x="196.154"
            y="219.435"
            style={{
              fill: "#CFF09E",
            }}
            width="296.061"
            height="163.65"
          />
        </g>
        <g>
          <path
            style={{
              fill: "#507C5C",
            }}
            d="M492.215,204.559h-38.782V14.876C453.433,6.66,446.772,0,438.557,0H175.581
          c-0.183,0-0.363,0.021-0.546,0.027c-0.167,0.006-0.332,0.013-0.498,0.025c-0.643,0.046-1.282,0.118-1.909,0.245
          c-0.013,0.003-0.027,0.007-0.042,0.01c-0.617,0.126-1.22,0.305-1.815,0.509c-0.155,0.054-0.309,0.109-0.463,0.167
          c-0.585,0.222-1.159,0.469-1.711,0.762c-0.019,0.01-0.042,0.018-0.061,0.03c-0.568,0.305-1.108,0.66-1.635,1.04
          c-0.135,0.098-0.268,0.196-0.4,0.299c-0.522,0.402-1.028,0.827-1.497,1.3L9.21,161.868c-0.35,0.353-0.678,0.721-0.988,1.104
          c-0.207,0.254-0.388,0.521-0.576,0.784c-0.092,0.131-0.195,0.256-0.283,0.388c-0.214,0.324-0.405,0.66-0.592,0.998
          c-0.046,0.083-0.1,0.162-0.143,0.245c-0.183,0.347-0.342,0.701-0.495,1.056c-0.037,0.086-0.082,0.168-0.116,0.256
          c-0.14,0.341-0.256,0.689-0.369,1.038c-0.036,0.112-0.08,0.219-0.113,0.33c-0.095,0.321-0.17,0.646-0.242,0.971
          c-0.033,0.147-0.076,0.293-0.106,0.442c-0.058,0.3-0.095,0.604-0.134,0.907c-0.024,0.177-0.057,0.351-0.074,0.53
          c-0.028,0.303-0.034,0.607-0.045,0.912c-0.006,0.167-0.024,0.332-0.024,0.498v4.792c0,8.216,6.66,14.876,14.876,14.876h155.796
          c8.216,0,14.876-6.66,14.876-14.876V29.752h233.225v174.807H196.156c-8.216,0-14.876,6.66-14.876,14.876v163.644
          c0,8.216,6.66,14.876,14.876,14.876h296.059c8.215,0,14.876-6.66,14.876-14.876V219.435
          C507.091,211.219,500.43,204.559,492.215,204.559z M50.691,162.246L160.705,51.06v111.186H50.691z M477.339,368.203H211.032
          V234.311h266.308V368.203z"
          />
          <path
            style={{
              fill: "#507C5C",
            }}
            d="M255.692,313.875l-16.073,27.302c-0.771,1.211-2.312,1.761-4.073,1.761
          c-4.734,0-11.45-3.743-11.45-8.476c0-0.991,0.33-1.981,0.992-3.082l19.046-29.393l-18.275-29.283
          c-0.771-1.211-1.101-2.312-1.101-3.413c0-4.623,6.275-8.148,11.12-8.148c2.422,0,4.073,0.881,5.174,2.862l14.642,25.54
          l14.641-25.54c1.101-1.981,2.754-2.862,5.175-2.862c4.844,0,11.12,3.523,11.12,8.148c0,1.101-0.332,2.202-1.101,3.413
          l-18.275,29.283l19.046,29.393c0.66,1.101,0.991,2.092,0.991,3.082c0,4.734-6.715,8.476-11.449,8.476
          c-1.761,0-3.413-0.55-4.073-1.761L255.692,313.875z"
          />
          <path
            style={{
              fill: "#507C5C",
            }}
            d="M301.595,342.277c-3.744,0-7.487-1.761-7.487-5.284v-70.017c0-3.633,4.295-5.174,8.586-5.174
          c4.295,0,8.586,1.541,8.586,5.174v60.329h25.1c3.304,0,4.955,3.744,4.955,7.487c0,3.743-1.651,7.486-4.955,7.486h-34.786V342.277z"
          />
          <path
            style={{
              fill: "#507C5C",
            }}
            d="M381.294,320.7c0-13.321-34.899-11.01-34.899-36.77c0-16.514,14.422-22.788,28.182-22.788
          c5.836,0,21.909,1.101,21.909,9.689c0,2.972-1.981,9.027-6.827,9.027c-3.963,0-6.055-4.183-15.083-4.183
          c-7.816,0-11.008,3.192-11.008,6.605c0,11.01,34.899,8.918,34.899,36.66c0,15.853-11.56,24.44-27.523,24.44
          c-14.421,0-26.531-7.045-26.531-14.312c0-3.744,3.304-9.248,7.486-9.248c5.175,0,8.476,8.148,18.715,8.148
          C375.68,327.967,381.294,325.985,381.294,320.7z"
          />
          <path
            style={{
              fill: "#507C5C",
            }}
            d="M433.473,313.875l-16.073,27.302c-0.772,1.211-2.313,1.761-4.073,1.761
          c-4.735,0-11.449-3.743-11.449-8.476c0-0.991,0.33-1.981,0.991-3.082l19.046-29.393l-18.275-29.283
          c-0.771-1.211-1.101-2.312-1.101-3.413c0-4.623,6.276-8.148,11.12-8.148c2.422,0,4.073,0.881,5.175,2.862l14.642,25.54
          l14.642-25.54c1.099-1.981,2.752-2.862,5.174-2.862c4.845,0,11.12,3.523,11.12,8.148c0,1.101-0.33,2.202-1.101,3.413
          l-18.274,29.283l19.046,29.393c0.66,1.101,0.991,2.092,0.991,3.082c0,4.734-6.717,8.476-11.449,8.476
          c-1.763,0-3.414-0.55-4.073-1.761L433.473,313.875z"
          />
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    ),
  
    iconoLupa: (
      <svg
      x="0px"
      y="0px"
      width="24"
      height="24"
        viewBox="0 0 512 512"
      >
        <g>
          <path
             style={{
              fill: "#507C5C",
            }}
            className="st0"
            d="M172.625,102.4c-42.674,0-77.392,34.739-77.392,77.438c0,5.932,4.806,10.74,10.733,10.74
          c5.928,0,10.733-4.808,10.733-10.74c0-30.856,25.088-55.959,55.926-55.959c5.928,0,10.733-4.808,10.733-10.74
          C183.358,107.208,178.553,102.4,172.625,102.4z"
          />
          <path
             style={{
              fill: "#076620",
            }}
            className="st0"
            d="M361.657,301.511c19.402-30.436,30.645-66.546,30.645-105.244C392.302,88.036,304.318,0,196.151,0
          c-38.676,0-74.765,11.25-105.182,30.663C66.734,46.123,46.11,66.759,30.659,91.008C11.257,121.444,0,157.568,0,196.267
          c0,108.217,87.998,196.266,196.151,196.266c38.676,0,74.779-11.264,105.197-30.677C325.582,346.396,346.206,325.76,361.657,301.511
          z M259.758,320.242c-19.075,9.842-40.708,15.403-63.607,15.403c-76.797,0-139.296-62.535-139.296-139.378
          c0-22.912,5.558-44.558,15.394-63.644c13.318-25.856,34.483-47.019,60.323-60.331c19.075-9.842,40.694-15.403,63.578-15.403
          c76.812,0,139.296,62.521,139.296,139.378c0,22.898-5.558,44.53-15.394,63.616C306.749,285.739,285.598,306.916,259.758,320.242z"
          />
          <path
             style={{
              fill: "#076620",
            }}
            className="st0"
            d="M499.516,439.154L386.275,326.13c-16.119,23.552-36.771,44.202-60.309,60.345l113.241,113.024
          c8.329,8.334,19.246,12.501,30.148,12.501c10.916,0,21.833-4.167,30.162-12.501C516.161,482.83,516.161,455.822,499.516,439.154z"
          />
        </g>
      </svg>
    ),
  };
  